// Static site copy. Projects and facts live in the CMS (collections `projektet` and `faktet`).

export const hero = {
    eyebrow: "Grupi i vullnetarëve përmirësues të shoqërisë",
    entry: "jap",
    pronunciation: "/jap/",
    grammar: "folje · dhashë, dhënë",
    definitions: [
        "T’u japësh të tjerëve nga koha, aftësitë, përvoja dhe pasuria jote.",
        "Grup vullnetarësh që punon për përmirësimin e shoqërisë."
    ],
    motto: "Më i miri prej jush, më i dobishmi për njerëzit.",
    attribution: "Muhamedi (paqja qoftë mbi të)",
    primaryCta: "Bashkohu",
    secondaryCta: "Shiko projektet",
    scrollCue: "Lëviz poshtë"
}

export const conjugation = [
    { id: 'une', line: "Unë jap.", note: "Një vendim." },
    { id: 'ti', line: "Ti jep.", note: "Një ftesë." },
    { id: 'ne', line: "Ne japim.", note: "Një shoqëri më e mirë." }
]

// The statement is split into words for the scroll reveal. Gift words point to the gifts below.
export const statement = {
    label: "Manifesti",
    words: [
        "JAP-i", "është", "bashkim", "vullnetar,", "anëtarët", "e", "të", "cilit", "japin", "nga",
        { word: "koha", gift: 1, trailing: "," },
        { word: "aftësitë", gift: 2, trailing: "," },
        { word: "përvoja", gift: 3, trailing: "" },
        "dhe",
        { word: "pasuria", gift: 4, trailing: "" },
        "e", "tyre", "për", "të", "mirën", "e", "përgjithshme."
    ] as Array<string | { word: string, gift: number, trailing: string }>,
    full: "JAP-i është bashkim vullnetar, anëtarët e të cilit japin nga koha, aftësitë, përvoja dhe pasuria e tyre për të mirën e përgjithshme.",
    aim: "Kjo iniciativë synon që përmes projekteve dhe veprimtarive të tjera të ndikojë dukshëm në përmirësimin e shoqërisë."
}

export const giftsIntro = {
    label: "Çfarë japim",
    title: "Katër mënyra për të dhënë",
    text: "Çdo anëtar jep atë që ka. Bashkë, këto katër dhurata bëhen projekte që i shërbejnë shoqërisë.",
    hint: "Vazhdo të lëvizësh",
    outroTitle: "Cila është dhurata jote?",
    outroCta: "Bashkohu me JAP-in"
}

export const gifts = [
    {
        id: 'koha',
        number: '01',
        word: "Koha",
        note: "Orët që anëtarët i ndajnë nga jeta e tyre për të mirën e përgjithshme.",
        image: '/images/dhurata/koha-vullnetaret.jpg',
        alt: "Vullnetarë që mbushin bashkë pako me ushqime në një sallë komunitare"
    },
    {
        id: 'aftesite',
        number: '02',
        word: "Aftësitë",
        note: "Mjeshtëri profesionale nga fusha të ndryshme, në shërbim të projekteve.",
        image: '/images/dhurata/aftesite-mjeshtri.jpg',
        alt: "Një marangoz me përvojë që i mëson një të reje si ta punojë drurin"
    },
    {
        id: 'pervoja',
        number: '03',
        word: "Përvoja",
        note: "Dija e fituar në biznes dhe në punë, e ndarë me të tjerët.",
        image: '/images/dhurata/pervoja-mentorimi.jpg',
        alt: "Një sipërmarrëse me përvojë që këshillon një të ri mbi një fletore të hapur"
    },
    {
        id: 'pasuria',
        number: '04',
        word: "Pasuria",
        note: "Burime personale, të vëna në shërbim të së mirës së përgjithshme.",
        image: '/images/dhurata/pasuria-dhurimi.jpg',
        alt: "Një dorë që lëshon një zarf në kutinë e donacioneve pranë librave dhe mjeteve shkollore"
    }
]

export const factsIntro = {
    label: "Fakte",
    title: "Fakte për JAP-in",
    text: "Dhjetëra organizime dhe aktivitete të ndryshme në të mirën e përgjithshme."
}

export const projectsIntro = {
    label: "Projektet",
    title: "Projektet",
    titleAccent: "e grupit",
    text: "Nisma që i shërbejnë shoqërisë: nga shëndeti mendor te libri, nga debati publik te biznesi.",
    all: "Të gjitha",
    visit: "Vizito faqen",
    empty: "Projektet do të shfaqen këtu së shpejti."
}

export const brochure = {
    label: "Broshura",
    title: "Broshura",
    titleAccent: "e grupit JAP",
    text: "Shfleto broshurën zyrtare të grupit JAP, në një dokument të vetëm.",
    cta: "Hap broshurën",
    meta: "PDF · 1.3 MB",
    alt: "Kopertina e broshurës së JAP, me thënien Më i miri prej jush, më i dobishmi për njerëzit"
}

export const join = {
    label: "Bashkohu",
    title: "Bashkohu",
    text: "Jep nga koha, aftësitë, përvoja ose pasuria jote. Bëhu pjesë e më shumë se 80 vullnetarëve që punojnë për një shoqëri më të mirë.",
    imageAlt: "Duar të shumta të bashkuara në mes, shenjë e punës së përbashkët",
    imageCaption: "Bashkë japim më shumë.",
    gifts: ["Kohë", "Aftësi", "Përvojë", "Pasuri"] as const,
    privacy: "Të dhënat e tua përdoren vetëm që ekipi i JAP-it të të kontaktojë.",
    submit: "Dërgo aplikimin",
    sending: "Po dërgohet",
    successTitle: "Faleminderit!",
    successText: "Aplikimi yt arriti te ekipi i JAP-it. Do të të kontaktojmë së shpejti.",
    again: "Dërgo një aplikim tjetër"
}

export const contact = {
    label: "Bashkëpunim",
    question: "Keni ide për bashkëpunim?",
    prompt: "Na shkruani në këtë email:",
    credit: "Punuar nga",
    creditName: "Azwedo",
    creditUrl: 'https://azwedo.com/',
    backToTop: "Kthehu lart",
    closing: "Ne japim."
}
